import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-design',
  templateUrl: './custom-design.component.html',
  styleUrls: ['./custom-design.component.css']
})
export class CustomDesignComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
